import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { REMINDERS_TABLE_ACTIONS } from "../../enums";
import {
    REMINDER_DELETE_PERMISSION,
    REMINDER_UPDATE_PERMISSION,
} from "components/dashboard/ServiceModule/permissions";

const RemindersTableActions = ({ handleActionModal }) => {
    return (
        <>
            <Dropdown
                size='sm'
                placeholder={
                    <ReactSVG
                        src={asset?.icons?.horizontalEllipsis}
                        className='d-inline-flex'
                    />
                }
                ddValueClass='borderless'
                className='table__dropdown'
                ddOptionsClass='table__dropdown'
                anchor={false}
                changeValue={false}
                onChange={({ value }) => handleActionModal(value)}
                options={[
                    {
                        value: REMINDERS_TABLE_ACTIONS.EDIT_REMINDER,
                        label: "Edit Reminder",
                        baseResources: REMINDER_UPDATE_PERMISSION,
                    },
                    {
                        value: REMINDERS_TABLE_ACTIONS.DELETE_REMINDER,
                        label: "Delete Reminder",
                        baseResources: REMINDER_DELETE_PERMISSION,
                    },
                ]}
            />
        </>
    );
};

export default RemindersTableActions;
